import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ENV } from "./env";
import { Root } from "./Root";
import { initTeams, likelyInTeams } from "./teams";
import "@guestpilot/ui-kit/styles.css";

async function boot() {
  // the browser payment page (opened from Teams, D-165) and a page opened in an ordinary browser are not Teams pages: no handshake to wait for
  const teams = location.pathname === "/pay" || !likelyInTeams() ? await initTeams(0) : await initTeams();
  if (ENV.mock) {
    const { worker } = await import("./mocks/browser");
    await worker.start({ onUnhandledRequest: "bypass" });
  }
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <Root teams={teams} />
    </StrictMode>,
  );
}

void boot();
